<!-- kept while loading or filtering: lib-list-commandes shows its own "no result" state and keeps the filters -->
@if (commandes.length > 0 || loading || hasActiveFilter) {
  <div
    class="flex justify-center my-4 w-full"
    >
    <lib-list-commandes
      class="w-full"
      [labels]="'lib.listCommandes' | translate"
      [title]="'account.orders.title' | translate"
      [eyebrow]="'account.common.eyebrow' | translate"
      [ordersList]="commandes"
      [bank]="bank"
      [currentPage]="pageIndex"
      [rowsLimit]="pageSize"
      [totalElements]="totalElements"
      [loading]="loading"
      [searchQuery]="searchQuery"
      [statusOptions]="statusOptions"
      [selectedStatus]="selectedStatus.value ?? ''"
      [startDate]="startDate"
      [endDate]="endDate"
      (searchChange)="onSearchChange($event)"
      (statusChange)="onStatusChange($event)"
      (dateChange)="onDateChange($event)"
      (pageChange)="onPageChange($event)"
      (itemsPerPageChange)="onItemPerPageChange($event)"
      (orderClick)="handleOrderClick($event)"
    ></lib-list-commandes>
  </div>
} @else {
  <div class="w-[100%] flex flex-col justify-start items-center gap-9">
    <ws-empty-state
      [title]="'account.orders.emptyTitle' | translate"
      [description]="'account.orders.emptyDescription' | translate"
      [bankColor]="bank"
    ></ws-empty-state>
  </div>
}
